import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

class FileListItem extends Component{

	constructor(props){
		super(props);
		this.state = {
			open: false
		};
	}

	handleClickDescriptionButton = (e) => {
		const open = this.state.open;
		this.setState({
			open: !open
		});
	};

	renderDescription = (isFirmware, description) => {
		if(!isFirmware || description === null || description.length === 0){
			return null;
		}

		const className = this.state.open
			? 'file-list__item-body opened'
			: 'file-list__item-body closed';

		return (
			<div className={className}>
				{description}
				{description.length}
			</div>
		);
	};

	renderDescriptionButton = (isFirmware,description) => {
		if(!isFirmware || description == null || description.length === 0){
			return null;
		}

		const className = this.state.open
			? 'btn btn-description opened'
			: 'btn btn-description closed';

		const text = this.state.open
			? <FormattedMessage id="file.description.opened" />
			: <FormattedMessage id="file.description.closed" />;

		return (
			<button className={className} onClick={this.handleClickDescriptionButton}>
				{text}
			</button>
		);
	};

	render(){
		const { file } = this.props;
		return (
			<li className="file-list__item">
				<div className="file-list__item-head">
					<span className="file-list__item-name">
						{file.name}
					</span>
					{this.renderDescriptionButton(file.fileType.includes('FIRMWARE'),file.description)}
					<a className="btn btn-download" href={file.link} target="_blank">
						<FormattedMessage id="product.file.download" />
					</a>
				</div>
				{this.renderDescription(file.fileType.includes('FIRMWARE'),file.description)}
			</li>
		);
	};
}

export default FileListItem;


// WEBPACK FOOTER //
// ./src/components/common/FileListItem.js